const yellow300Color = '#E4CF67';

export default yellow300Color;
